import { render, staticRenderFns } from "./SchoolTeacherList.vue?vue&type=template&id=16d80d2e&scoped=true"
import script from "./SchoolTeacherList.vue?vue&type=script&lang=js"
export * from "./SchoolTeacherList.vue?vue&type=script&lang=js"
import style0 from "./SchoolTeacherList.vue?vue&type=style&index=0&id=16d80d2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d80d2e",
  null
  
)

export default component.exports